import {
  FETCHING_TARGETED_CONTENT,
  FETCHED_TARGETED_CONTENT,
  GET_STORED_TARGETED_CONTENT,
  API_ERROR
} from "./constants";
import { emitContentTargetingEvent, emitNewRelicEvent } from "./events";
import Storage from "./storage";

export const requestTargetedContent = parameters => {
  return (dispatch, getState, { api }) => {
    const { fetchTargetedContent } = api;

    const storage = new Storage();
    const storedData = storage.getData(parameters);

    if (storedData) {
      emitContentTargetingEvent(storedData);
      dispatch({ type: GET_STORED_TARGETED_CONTENT, payload: storedData });
    } else {
      dispatch({ type: FETCHING_TARGETED_CONTENT });
      fetchTargetedContent(parameters)
        .then(res => {
          storage.setData(res.items, parameters);
          emitContentTargetingEvent(res.items);
          dispatch({ type: FETCHED_TARGETED_CONTENT, payload: res.items });
        })
        .catch(err => {
          emitContentTargetingEvent(null);
          emitNewRelicEvent(err);
          dispatch({ type: API_ERROR });
        });
    }
  };
};
